import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { loadFavorites } from '../../../redux-flow/actions/wallet_transactions'
import Navbar from '../../../Components/Navbar'
import Container from 'react-bootstrap/Container'
import WalletSaldo from '../../../Components/WalletSaldo'
import Depositar from './Depositar'
import Transferir from './Transferir'
import Footer from '../../../Components/Footer'
import { Redirect } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import './brlDepRes.css'
import BreadCrumb from '../../../Components/BreadCrumb'
import InsideMenu from '../../../Components/InsideMenu'
import SideMenu from '../../../Components/SideMenu'
import moment from 'moment'
// import LoginWallet from '../loginWallet'
import { fetchUserInfo } from '../../../redux-flow/actions/users'
import SideBar from '../../../Components/SideBar'

class BrlDepResWallet extends PureComponent {
    constructor(props) {
    super(props)
    this.state = {
        tabAtiva: 'Depositar',
        password: '',
        loading: false,
        }
                    // fillBackground: false,
    }

    componentDidMount() {
        const { userid, onLoad } = this.props
        if(onLoad && userid) {
            onLoad(userid, 'brl')
        }
    }

    onClickTab = (id) => {
        if(this.state.tabAtiva != id){
            this.setState({tabAtiva:id})
        }
    }

    handleChange = (e) => {
        this.setState({
            password: e.target.value
        })
    }


        render() {

            const { logged, userLogged, isLoading, favorites, userExpiration, loginExpired, walletLogged } = this.props

            return (
    
                <>
                    <Navbar loggedArea={true}/>
                    {!logged ? <Redirect to="/login" /> : userLogged.cpf === null || userLogged.cep === null ? <Redirect to="/finalizar-cadastro" /> : (
                        userLogged.permissao === 0 || userLogged.permissao === 2 || userLogged.permissao === 4 ? <Redirect to="/minhaconta" /> :
                        <div>
                            
                            <Container>
                                <div className="section minhaContaWrapper">
                                    <Row>
                                        <Col md={12} className="p-0">
                                            <InsideMenu />
                                        </Col>
                                    </Row>
                                </div>

                                <div className="section insideSec">
                                    <Row>
                                        <Col md={2} className="p-0" style={{borderRight: '1px solid #F6F3FF'}}>
                                            <SideBar permissao={userLogged.permissao} nivelVerificacao={userLogged.nivelVerificacao} />
                                        </Col>
                                        <Col md={10}>
                                                <div>
                                                    <WalletSaldo type="brl" />
                                                    <BreadCrumb page="BRL Depositar/Transferir" link="/wallet/brl" />
                                                    <Row>
                                                        <Col md={3}>
                                                            <SideMenu tabAtiva={this.state.tabAtiva} onClick={this.onClickTab} tab1='Depositar' tab2='Transferir' type="brl" />
                                                        </Col>
                                                        <Col md={1} className='p-0'/>
                                                        {this.state.tabAtiva == 'Depositar' ?                                             
                                                            <Col className='p-0' md={7}> <Depositar/> </Col> : <Col className='p-0' md={7}> <Transferir isLoading={isLoading} favorites={favorites} /> </Col>}                                       
                                                    </Row>
                                                </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Container> 
                        </div>
                    )}
                </>
            )
        }
    }

const mapStateToProps = state => ({
    logged: state.login.logged,
    userLogged: state.users.userLogged,
    userid: state.login.userid,
    favorites: state.wallet_transactions.favorites,
    isLoading: state.wallet.isLoading,
    userExpiration: state.wallet.userExpiration,
    loginExpired: state.wallet.loginExpired,
    walletLogged: state.wallet.walletLogged
})

const mapDispatchToProps = dispatch => ({
    onLoad: (id, type) => {
        dispatch(loadFavorites(id, type))
        dispatch(fetchUserInfo(id))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(BrlDepResWallet)